export default function checkAdminCorporation({ user }) {
    if (user) {
        return user.idOfCurrentCorporation === 'admin';
    }

    return false;
}
